import React from 'react';

interface LoadingContainerProps {
    message?: string;
    className?: string;
}

export const LoadingContainer: React.FC<LoadingContainerProps> = ({
    message = "Carregando...",
    className = "bg-white shadow sm:rounded-lg"
}) => {
    return (
        <div className={className}>
            <div className="px-4 py-5 sm:p-6">
                <div className="flex items-center justify-center">
                    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-indigo-600"></div>
                    <span className="ml-2 text-gray-600">{message}</span>
                </div>
            </div>
        </div>
    );
}; 